module.exports = __webpack_public_path__ + "img/addCard.4f9fda51.png";